import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import '../styles.css'

interface RouterContext {
  auth: {
    isPending: boolean
    isAuthenticated: boolean
    waitForSession: () => Promise<boolean>
  }
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <Outlet />
    </>
  ),
})
